import React, {useState,useEffect} from "react";
import { configData } from "../config";
import { useNavigate,useLocation,useParams } from 'react-router-dom';
import { Link } from '@mui/material';
import { Helmet } from 'react-helmet';
import Loading from './Loading';
import './classes/MyScoutRequestReports.css';
import ScoutSidebar from './ScoutSidebar';
import { DataGrid } from '@mui/x-data-grid';



const MyScoutRequestReports = () => {

    const [isLoading, setIsLoading] = useState(true); 

    const location  = useLocation();
    const loggedin_uid = localStorage.getItem('uid');
    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const domain_url = configData.DOMAIN_URL;
    var {uid} = useParams();
    const[message,setMessage] = useState([]);
    const [rows, setRows] = React.useState([]);
    const [rowCount, setRowCount] = React.useState(0);
    const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 50 });
    const [sortModel, setSortModel] = React.useState([]);
    const [filterModel, setFilterModel] = React.useState({ items: [] });
const columns = [   
    {
        field: 'player',
        headerName: 'Athlete',
        headerClassName: 'super-app-theme--header',
        minWidth: 105, 
        flex:1,
        sortable: false,
        filterable: false,   
    },
    {
        field: 'requester',
        headerName: 'Requested By',
        headerClassName: 'super-app-theme--header',
        minWidth: 125, 
        flex:1,
        sortable: false,
        filterable: false,   
    },
    {
        field: 'location',
        headerName: 'Location',
        headerClassName: 'super-app-theme--header',
        minWidth: 105, 
        flex:1,
        sortable: false,
        filterable: false,   
    },
    {
        field: 'date',
        headerName: 'Date',
        headerClassName: 'super-app-theme--header',
        minWidth: 110, 
        flex:1,
        sortable: false,
        filterable: false,  
    },
    {
        field: 'sport',
        headerName: 'Sport',
        headerClassName: 'super-app-theme--header',
        minWidth: 95, 
        flex:1,
        sortable: false,
        filterable: false,  
    },
    {
        field: 'view',
        headerName: 'View',
        headerClassName: 'super-app-theme--header',
        minWidth: 90, 
        flex:1,     
        sortable: false,
        filterable: false,
        renderCell: (params) => (
            <Link href={params.row.view_url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
                {params.row.linkText || 'View'}
            </Link>
        )
    },
    { field: 'deny', headerName: '',sortable: false,cellClassName:'deny_column',headerClassName:'deny_header',minWidth:100, flex:1, renderCell: (params) => (
        <><img  style={{cursor: "pointer" }} onClick={() => handleDenyClick(params.row.sid)} className="approval_image"  src="/basic/web/images/deny.gif" alt="Approve" border="0" align="top" /></>
          )},
]; 
     React.useEffect(() => {
        const fetchData = async () => {
          // Simulate API call to your server
          // In a real application, replace this with your actual fetch logic
          try {
            setIsLoading(true);
            const response = await fetch(app_url+'smwwscout/myacceptedscoutrequest', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                page: paginationModel.page,
                pageSize: paginationModel.pageSize,
                sortModel,
                filterModel,
                loggedin_uid:loggedin_uid
              }),
            });
            const data = await response.json();
            console.log(data.data.rows);
            setRows(data.data.rows);
            setRowCount(data.data.totalRowCount); // Server should return totalRowCount
          }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
        };
        
        fetchData();
    
      }, [paginationModel, sortModel, filterModel]); // Re-fetch data when these change

      const handleDenyClick = async (sid) => {
      
      try {
        const response = await fetch(
                app_url+'smwwscout/denyscoutreport',
                {
                    method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                sid: sid,
                loggedin_id: localStorage.getItem('drupal_uid')
                
              }),
                }
            )
            const responsedata = await response.json();
            if(responsedata.data.msg == "Success") {
              alert("Denied");
                window.location.reload();
            }
            
      } catch (error) {
        console.error('API call failed:', error);
      }
    };
         useEffect(() => {
                 Promise.all([
                     checkpermissionforpageaccess()
                 ])
                 .then(() => {
              
                 setIsLoading(false);
                 })
              
             },[]);
              async function checkpermissionforpageaccess() {
       
          
               const response = await fetch(
                    app_url+'smwwscout/checkpermissionforotherpageaccess?uid='+loggedin_uid,
                   {
                       method: "GET",
     
                       headers: {
                       'Content-Type': 'application/json',
                       },
                   }
               )           
               const responsedata = await response.json();
               if(responsedata.data.msg === "Success") {
                   
               } 
                if(responsedata.data.msg === "Error") {
                   setMessage(responsedata.data.result);
               } 
   
          
       }
      return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <div id="main">
                    <Helmet><title>My Accepted Scouting Report Requests</title></Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        <div className="my-scout-request-reports-container">
                          {message.length > 0 ? (
                <div>
                  {message.map((item, index) => {
                    return <><div dangerouslySetInnerHTML={{ __html: item }} /><br /></>
          
                  })}  
                </div>
              ) : ( 
                            <><h1>My Accepted Scouting Report Requests</h1>
                            <div className="my-scout-request-reports-table" style={{ width: '100%', overflowX: 'auto',}}>
                                <DataGrid
                                    autoHeight
                                    rows={rows}
                                    columns={columns} 
                                    rowCount={rowCount}
                                    disableAutosize
                                    getRowHeight={() => 'auto'}
                                    paginationMode="server"
                                    sortingMode="server"
                                    filterMode="server"
                                    filterModel={filterModel}
                                    onFilterModelChange={setFilterModel}
                                    paginationModel={paginationModel}
                                    onPaginationModelChange={setPaginationModel}
                                    sortModel={sortModel}
                                    onSortModelChange={setSortModel}
                                    pageSizeOptions={[5, 10, 25, 50]}
                                    pageSize={50}
                                    getRowId={() => crypto.randomUUID()}                                                                 
                                    sx={{
                                        fontFamily: '"Open Sans", sans-serif, Arial, Verdana',
                                        '& .MuiDataGrid-row': { marginTop: 1, marginBottom: 1 },
                                        '& .coloured': { textAlign: 'center', color: '#7181AD' },
                                        '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': { display: 'block' },
                                        '& .super-app-theme--header': { fontSize: '14px' },
                                        '.MuiDataGrid-columnHeaderTitle': { fontWeight: 'bold !important',whiteSpace:'normal' },
                                        '& .MuiDataGrid-cell': {
                                        whiteSpace: 'normal',
                                        wordWrap: 'break-word',
                                        lineHeight: '1.4',
                                        alignItems: 'center',
                                        display: 'flex',
                                        },
                                        // '& .MuiTablePagination-actions': { marginRight: 10 },
                                        '& .header-link':{color: "#2C99D2"},
                                    }}
                                    disableColumnResize={true}
                                />
                            </div></>
              )}
                        </div>
                    </div>
                    <div className="right">
                        <ScoutSidebar />
                    </div>
                </div>
            )}
        </>
    );
};
export default MyScoutRequestReports;